// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"372":"cards","517":"calendar","552":"rules","774":"raspisanie","866":"partners","962":"home"}[chunkId] || chunkId) + "-legacy." + {"229":"53048670","372":"9f6c14f9","517":"bf1acd5a","552":"33d8e7f3","774":"c074f9bb","866":"9827cdbb","962":"63096a6c"}[chunkId] + ".js";
};